export const portInPhoneRegex = /^(9[\d]{7})$/;
